export default function computeImageDetailStats(workcardDetails) {
  const rtnObj = {
    notStartedImages: 0,
    inReviewImages: 0,
    incompleteImages: 0,
    completeImages: 0,
    totalImages: 0,
  }
  for (const key in workcardDetails) {
    const val = workcardDetails[key]
    Array.isArray(val) &&
      val.forEach(() => {
        rtnObj[`${key}Images`]++
        rtnObj['totalImages']++
      })
  }
  return rtnObj
}
